// extracted by mini-css-extract-plugin
export default {"paper":"left-area-visible-filters-popover_paper__5yqv6","checkboxs":"left-area-visible-filters-popover_checkboxs__1yulv"};